
import { useEffect, useState, type ReactNode } from 'react';
import { useRouter } from '@/lib/navigation';
import { Loader2 } from 'lucide-react';
import {
  ADMIN_LOGIN_PATH,
  hydrateAdminSession,
  isAdminAuthenticated,
} from '@/lib/admin-auth';

type AdminAuthGateProps = {
  children: ReactNode;
};

export default function AdminAuthGate({ children }: AdminAuthGateProps) {
  const router = useRouter();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function verify() {
      if (!isAdminAuthenticated()) {
        router.replace(ADMIN_LOGIN_PATH);
        return;
      }

      const session = await hydrateAdminSession();
      if (cancelled) return;

      if (!session) {
        router.replace(ADMIN_LOGIN_PATH);
        return;
      }

      setReady(true);
    }

    verify();
    return () => {
      cancelled = true;
    };
  }, [router]);

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#030023]">
        <Loader2 className="h-8 w-8 animate-spin text-sky-400/80" aria-label="A verificar sessão" />
      </div>
    );
  }

  return <>{children}</>;
}
